import React from 'react';

import { useDeviceTypeIsMobile } from '@/hooks';
import { CustomTitle } from '@/components';

import { DesktopContainer } from './DesktopContainer';
import { MobileContainer } from './MobileContainer';

export default () => {
  const isMobile = useDeviceTypeIsMobile();

  return (
    <>
      <CustomTitle titlePrefix="Stream" />
      {isMobile ? <MobileContainer /> : <DesktopContainer />}
    </>
  );
};

export * from './types';
export * from './hooks';
export * from './state';
export * from './components';
